(() => {
  // node_modules/@shopify/theme-sections/section.js
  var SECTION_ID_ATTR = "data-section-id";
  function Section(container, properties) {
    this.container = validateContainerElement(container);
    this.id = container.getAttribute(SECTION_ID_ATTR);
    this.extensions = [];
    Object.assign(this, validatePropertiesObject(properties));
    this.onLoad();
  }
  Section.prototype = {
    onLoad: Function.prototype,
    onUnload: Function.prototype,
    onSelect: Function.prototype,
    onDeselect: Function.prototype,
    onBlockSelect: Function.prototype,
    onBlockDeselect: Function.prototype,
    extend: function extend(extension) {
      this.extensions.push(extension);
      var extensionClone = Object.assign({}, extension);
      delete extensionClone.init;
      Object.assign(this, extensionClone);
      if (typeof extension.init === "function") {
        extension.init.apply(this);
      }
    }
  };
  function validateContainerElement(container) {
    if (!(container instanceof Element)) {
      throw new TypeError(
        "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
      );
    }
    if (container.getAttribute(SECTION_ID_ATTR) === null) {
      throw new Error(
        "Theme Sections: The section container provided does not have an id assigned to the " + SECTION_ID_ATTR + " attribute."
      );
    }
    return container;
  }
  function validatePropertiesObject(value) {
    if (typeof value !== "undefined" && typeof value !== "object" || value === null) {
      throw new TypeError(
        "Theme Sections: The properties object provided is not a valid"
      );
    }
    return value;
  }
  if (typeof Object.assign != "function") {
    Object.defineProperty(Object, "assign", {
      value: function assign(target) {
        "use strict";
        if (target == null) {
          throw new TypeError("Cannot convert undefined or null to object");
        }
        var to = Object(target);
        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];
          if (nextSource != null) {
            for (var nextKey in nextSource) {
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true
    });
  }

  // node_modules/@shopify/theme-sections/theme-sections.js
  var SECTION_TYPE_ATTR = "data-section-type";
  var SECTION_ID_ATTR2 = "data-section-id";
  window.Shopify = window.Shopify || {};
  window.Shopify.theme = window.Shopify.theme || {};
  window.Shopify.theme.sections = window.Shopify.theme.sections || {};
  var registered = window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {};
  var instances = window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || [];
  function register(type, properties) {
    if (typeof type !== "string") {
      throw new TypeError(
        "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
      );
    }
    if (typeof registered[type] !== "undefined") {
      throw new Error(
        'Theme Sections: A section of type "' + type + '" has already been registered. You cannot register the same section type twice'
      );
    }
    function TypedSection(container) {
      Section.call(this, container, properties);
    }
    TypedSection.constructor = Section;
    TypedSection.prototype = Object.create(Section.prototype);
    TypedSection.prototype.type = type;
    return registered[type] = TypedSection;
  }
  function load(types, containers) {
    types = normalizeType(types);
    if (typeof containers === "undefined") {
      containers = document.querySelectorAll("[" + SECTION_TYPE_ATTR + "]");
    }
    containers = normalizeContainers(containers);
    types.forEach(function (type) {
      var TypedSection = registered[type];
      if (typeof TypedSection === "undefined") {
        return;
      }
      containers = containers.filter(function (container) {
        if (isInstance(container)) {
          return false;
        }
        if (container.getAttribute(SECTION_TYPE_ATTR) === null) {
          return false;
        }
        if (container.getAttribute(SECTION_TYPE_ATTR) !== type) {
          return true;
        }
        instances.push(new TypedSection(container));
        return false;
      });
    });
  }
  function unload(selector) {
    var instancesToUnload = getInstances(selector);
    instancesToUnload.forEach(function (instance) {
      var index = instances.map(function (e) {
        return e.id;
      }).indexOf(instance.id);
      instances.splice(index, 1);
      instance.onUnload();
    });
  }
  function getInstances(selector) {
    var filteredInstances = [];
    if (NodeList.prototype.isPrototypeOf(selector) || Array.isArray(selector)) {
      var firstElement = selector[0];
    }
    if (selector instanceof Element || firstElement instanceof Element) {
      var containers = normalizeContainers(selector);
      containers.forEach(function (container) {
        filteredInstances = filteredInstances.concat(
          instances.filter(function (instance) {
            return instance.container === container;
          })
        );
      });
    } else if (typeof selector === "string" || typeof firstElement === "string") {
      var types = normalizeType(selector);
      types.forEach(function (type) {
        filteredInstances = filteredInstances.concat(
          instances.filter(function (instance) {
            return instance.type === type;
          })
        );
      });
    }
    return filteredInstances;
  }
  function getInstanceById(id2) {
    var instance;
    for (var i = 0; i < instances.length; i++) {
      if (instances[i].id === id2) {
        instance = instances[i];
        break;
      }
    }
    return instance;
  }
  function isInstance(selector) {
    return getInstances(selector).length > 0;
  }
  function normalizeType(types) {
    if (types === "*") {
      types = Object.keys(registered);
    } else if (typeof types === "string") {
      types = [types];
    } else if (types.constructor === Section) {
      types = [types.prototype.type];
    } else if (Array.isArray(types) && types[0].constructor === Section) {
      types = types.map(function (TypedSection) {
        return TypedSection.prototype.type;
      });
    }
    types = types.map(function (type) {
      return type.toLowerCase();
    });
    return types;
  }
  function normalizeContainers(containers) {
    if (NodeList.prototype.isPrototypeOf(containers) && containers.length > 0) {
      containers = Array.prototype.slice.call(containers);
    } else if (NodeList.prototype.isPrototypeOf(containers) && containers.length === 0) {
      containers = [];
    } else if (containers === null) {
      containers = [];
    } else if (!Array.isArray(containers) && containers instanceof Element) {
      containers = [containers];
    }
    return containers;
  }
  if (window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", function (event) {
      var id2 = event.detail.sectionId;
      var container = event.target.querySelector(
        "[" + SECTION_ID_ATTR2 + '="' + id2 + '"]'
      );
      if (container !== null) {
        load(container.getAttribute(SECTION_TYPE_ATTR), container);
      }
    });
    document.addEventListener("shopify:section:unload", function (event) {
      var id2 = event.detail.sectionId;
      var container = event.target.querySelector(
        "[" + SECTION_ID_ATTR2 + '="' + id2 + '"]'
      );
      var instance = getInstances(container)[0];
      if (typeof instance === "object") {
        unload(container);
      }
    });
    document.addEventListener("shopify:section:select", function (event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onSelect(event);
      }
    });
    document.addEventListener("shopify:section:deselect", function (event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onDeselect(event);
      }
    });
    document.addEventListener("shopify:block:select", function (event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onBlockSelect(event);
      }
    });
    document.addEventListener("shopify:block:deselect", function (event) {
      var instance = getInstanceById(event.detail.sectionId);
      if (typeof instance === "object") {
        instance.onBlockDeselect(event);
      }
    });
  }

  // node_modules/@shopify/theme-cart/request.js
  function getDefaultRequestConfig() {
    return JSON.parse(
      JSON.stringify({
        credentials: "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json;"
        }
      })
    );
  }
  function fetchJSON(url, config) {
    return fetch(url, config).then(function (response) {
      if (!response.ok) {
        throw response;
      }
      return response.json();
    });
  }
  function cartUpdate(body) {
    var config = getDefaultRequestConfig();
    config.method = "POST";
    config.body = JSON.stringify(body);
    return fetchJSON("/cart/update.js", config);
  }

  // node_modules/@shopify/theme-cart/theme-cart.js
  function updateAttributes(attributes) {
    return cartUpdate({ attributes });
  }

  // app/scripts/common/_currency.js
  var AT_Currency = {
    currenciesCallback: function () {
      if (theme.currency.type != "2") {
        return;
      }
      var shopCurrency = "", defaultCurrency = "", cookieCurrency = "";
      let self = this;
      theme.currency.currenciesCallback = () => {
        if (Currency == null || theme.currency == null) {
          return;
        }
        Currency.format = theme.currency.currency_format;
        shopCurrency = theme.currency.shopCurrency;
        let formCurrency = document.querySelector('select[name="currency"]');
        if (formCurrency.value != shopCurrency) {
          formCurrency.value = shopCurrency;
          formCurrency.dispatchEvent(new Event("change"));
          formCurrency.closest("form").submit();
        }
        Currency.money_with_currency_format[shopCurrency] = theme.currency.moneyFormatWithCurrency_strip;
        Currency.money_format[shopCurrency] = theme.currency.moneyFormat_strip;
        defaultCurrency = shopCurrency;
        cookieCurrency = Currency.cookie.read();
        let spanMoney = document.querySelectorAll("span.money");
        spanMoney.length && spanMoney.forEach((s) => {
          s.setAttribute(`data-currency-${shopCurrency}`, s.innerHTML);
        });
        if (cookieCurrency == null) {
          if (shopCurrency !== defaultCurrency) {
            Currency.convertAll(shopCurrency, defaultCurrency);
          } else {
            Currency.currentCurrency = defaultCurrency;
          }
          Currency.cookie.write(defaultCurrency);
        } else if (cookieCurrency === shopCurrency) {
          Currency.currentCurrency = shopCurrency;
        } else {
          typeof cookieCurrency == "undefined" && (cookieCurrency = defaultCurrency);
          Currency.convertAll(shopCurrency, cookieCurrency);
          Currency.convertAll(Currency.currentCurrency, cookieCurrency);
        }
        self.updateState();
      };
      theme.currency.currenciesCallbackSpecial = (id2) => {
        if ("undefined" == typeof Currency || "undefined" == typeof theme.currency) {
          return;
        }
        let target = document.querySelectorAll(id2);
        target.length && target.forEach((element) => {
          element.setAttribute(`data-currency-${shopCurrency}`, element.innerHTML);
        });
        Currency.convertAll(shopCurrency, Currency.cookie.read(), id2, theme.currency.currency_format);
      };
    },
    convert: function (id2) {
      if (theme.currency.type != "2" || !theme.currency || !theme.currency.currenciesCallbackSpecial) {
        return;
      }
      theme.currency.currenciesCallbackSpecial(id2);
    },
    updateState: function () {
      if (theme.currency.type != "2") {
        return;
      }
      let currentCurrency = _AC.getCookie("currency");
      let labelCurrency = document.querySelectorAll("[data-currency-code]");
      let btnCurrency = document.querySelectorAll(".btn-currency[data-value]");
      currentCurrency.includes(";") && (currentCurrency = currentCurrency.split(";")[0]);
      labelCurrency.length && labelCurrency.forEach((c) => {
        c.textContent = currentCurrency;
      });
      btnCurrency.length && btnCurrency.forEach((b) => {
        b.getAttribute("data-value") == currentCurrency ? b.classList.add("active") : b.classList.remove("active");
      });
    },
    initEvents: function () {
      let self = this;
      _AC.addEvent(document, "click", ".btn-currency", (e) => {
        e.preventDefault();
        let _this = e.target, value = _this.getAttribute("data-value");
        switch (theme.currency.type) {
          case "1":
            let formCurrency = document.querySelector("form.shopify-currency-form");
            if (formCurrency == null) {
              return;
            }
            let optionSelect = formCurrency.querySelector("select");
            optionSelect.value = value;
            optionSelect.dispatchEvent(new Event("change"));
            formCurrency.submit();
            break;
          case "2":
            typeof Currency != "undefined" && Currency.convertAll(Currency.currentCurrency, value);
            self.updateState();
            break;
          default:
        }
      });
      theme.currency.type == "2" && theme.currency.currenciesCallback();
    },
    init: function () {
      if (!theme.currency.enable) {
        return;
      }
      let self = this;
      self.currenciesCallback();
      self.initEvents();
    }
  };
  var currency_default = AT_Currency;

  // app/scripts/common/_collection.js
  var AT_Main = theme.ac;
  var AT_Collection = {
    init: function (container) {
      this.container = container;
      this.themeCol_slide();
    },
    filterEvent: function () {
      let this2 = this;
      let settings = this.settings;
      AT_Main.addEvent(document, "click", ".toolbar_view-list a", function (e) {
        e.preventDefault();
        let value = e.target.dataset.view;
        updateAttributes({ viewMode: value }).then((state) => {
          location.reload();
        });
      });
      AT_Main.addEvent(document, "click", ".filter-toggle", function (e) {
        document.body.classList.toggle("filter-sidebar--active");
      });
      AT_Main.addEvent(document, "click", ".filter-toggle--close", function (e) {
        document.body.classList.remove("filter-sidebar--active");
      });
      AT_Main.addEvent(document, "click", ".tag-link", function (e) {
        e.preventDefault();
        let this4 = e.target;
        let url = this4.href;
        this2.loading();
        this2.filter(url);
        this4.closest("[data-prefix]").classList.add("filter-loading");
      });
    },
    filter: function (url) {
      let this2 = this;
      let settings = this.settings;
      let newURL = url + (!url.includes("?") ? "?" : "&") + "section_id=" + this.container.getAttribute("data-section-id");
      fetch(newURL).then((resp) => resp.text()).then((resp) => {
        let parser = new DOMParser();
        let body = parser.parseFromString(resp, "text/html"), productGrid = body.querySelector(settings.content);
        url = url.replace("?view=ajax", "").replace("&view=ajax", "");
        window.history.replaceState({ path: url }, "", url);
        document.querySelector(settings.content).replaceWith(productGrid);
        let dynamicContent = body.querySelectorAll(settings.dynamicContent);
        let dynamicID = settings.dynamicContent.replace(/\[|\]/g, "");
        dynamicContent.length && dynamicContent.forEach((f) => {
          let value = f.getAttribute(dynamicID), target = document.body.querySelector(`[${dynamicID}="${value}"]`);
          target.replaceWith(f);
        });
        currency_default.convert(settings.content + " .money");
        this2.loading(false);
      });
    },
    loading: function (bool = true) {
      if (bool) {
        document.body.classList.add("ajax-running");
        return;
      }
      document.body.classList.remove("ajax-running");
      return;
    },
    themeCol_slide() {
      let mainMedia = document.querySelector(".product-gallery--main");
      let thumbMedia = document.querySelector(".product-gallery--thumbnail");
      let featuredIndex = document.querySelector("[data-media-id].active");
      let startIndex = featuredIndex != null ? +featuredIndex.dataset.index : 0;
      if (theme.slider == null || !mainMedia || mainMedia.children.length < 2)
        return;
      this.mainGallery = theme.slider({
        container: mainMedia,
        items: 1,
        startIndex,
        gutter: 30,
        loop: false,
        controls: false,
        navContainer: thumbMedia,
        navAsThumbnails: true,
        mouseDrag: true,
        preventActionWhenRunning: false,
        preventScrollOnTouch: false
      });
      this.mainGallery.events.on("transitionStart", function (e) {
        let container = e.container;
        [...container.querySelectorAll("video")].map((i) => i.pause());
        let slideItem = container.querySelector(
          `.tns-item[data-index="${e.index}"]`
        );
        if (slideItem) {
          let video = slideItem.querySelector("video");
          video != null && video.play();
        }
      });
      if (thumbMedia != null) {
        let config = {
          container: thumbMedia,
          axis: "vertical",
          items: 6,
          startIndex,
          gutter: 8,
          loop: false,
          nav: false,
          controls: this.container.querySelector(".product-thumbnail--navigation") ? true : false,
          controlsContainer: this.container.querySelector(
            ".product-thumbnail--navigation"
          ),
          mouseDrag: true,
          preventActionWhenRunning: false,
          preventScrollOnTouch: false
        };
        this.thumbnailGallery = theme.slider(config);
      }
    }
  };
  if (theme.initSlider) {
  }
  load("*");
  var collection_default = AT_Collection;

  // app/scripts/collection.js
  register("collection", {
    onLoad: function () {
      collection_default.init(this.container);
    }
  });
  load("*");
})();
